// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDjxaynlV7h66md8O2v0g4Sf_zD-iF5Swg",
    authDomain: "intrapro-34kideas.firebaseapp.com",
    databaseURL: "https://intrapro-34kideas.firebaseio.com",
    projectId: "intrapro-34kideas",
    storageBucket: "intrapro-34kideas.appspot.com",
    messagingSenderId: "1096270661262"
  },
  finishSignUpUrl: 'http://localhost:4200/finishSignUp/',
  dominioUrl: 'http://localhost:4200'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts